export const SET_ANNOUNCEMENTS = 'SET_ANNOUNCEMENTS';
export const SET_CONTACTS = 'SET_CONTACTS';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT';
export const SET_CURRENT_PRESENTATION = 'SET_CURRENT_PRESENTATION';
export const SET_CURRENT_PRESENTATION_ID = 'SET_CURRENT_PRESENTATION_ID';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_DEVICE = 'SET_DEVICE';
export const SET_DEVICES = 'SET_DEVICES';
export const SET_FOLDERS = 'SET_FOLDERS';
export const SET_GROUP = 'SET_GROUP';
export const SET_GROUPS = 'SET_GROUPS';
export const SET_IMPORT_USERS = 'SET_IMPORT_USERS';
export const SET_LABEL = 'SET_LABEL';
export const SET_LABELS = 'SET_LABELS';
export const SET_LOCALES = 'SET_LOCALES'; // MLD-1323
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const READ_NOTIFICATIONS = 'READ_NOTIFICATIONS';
export const READ_NOTIFICATION = 'READ_NOTIFICATION';
export const SET_PRESENTATIONS = 'SET_PRESENTATIONS';
export const SET_PRESENTATION = 'SET_PRESENTATION';
export const RESET_PRESENTATION_FILTER = 'RESET_PRESENTATION_FILTER';
export const SET_PRESENTATION_FILTER = 'SET_PRESENTATION_FILTER';
export const SET_PRESENTATION_COMMENT_COUNT = 'SET_PRESENTATION_COMMENT_COUNT';
export const SET_PRESENTATION_SUBSCRIBERS = 'SET_PRESENTATION_SUBSCRIBERS';
export const SET_PRESENTATION_SUBSCRIBER_COUNT = 'SET_PRESENTATION_SUBSCRIBER_COUNT';
export const SET_RELOAD_REQUIRED = 'SET_RELOAD_REQUIRED'; // MLD-915
export const SET_SHARE_TEMPLATES = 'SET_SHARE_TEMPLATES';
export const SET_SHARE_THEMES = 'SET_SHARE_THEMES'; // MLD-967
export const SET_SPARK = 'SET_SPARK';
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const SET_USER = 'SET_USER';
export const SET_USERS = 'SET_USERS';
export const SET_TEAM = 'SET_TEAM';
export const SET_TEAMS = 'SET_TEAMS';
export const SET_TIMEZONES = 'SET_TIMEZONES';
export const SET_TITLE = 'SET_TITLE';
export const SET_WEBHOOKS = 'SET_WEBHOOKS';
export const SET_MOBILE = 'SET_MOBILE';
export const TOGGLE_MOBILE = 'TOGGLE_MOBILE';
export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
